import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import JoinLinkage from '../../common/JoinLinkage';
import ExplicitTag from '../../svg/ExplicitTag';

function ColumnTrack({ width, style, containerStyle, item, includeRemixers = false }) {
  return (
    <div style={{ width, display: `flex`, flexDirection: `row`, position: `relative`, ...style }}>
      <div className={`container-ellipsis`} style={{display: `flex`, flexDirection: `column`, zIndex: 50, width: Config.LIST_NAME_WIDTH, ...containerStyle }}>
        <JoinLinkage label={`${item.title} ${(item.mix_name !== '') ? ` - ${item.mix_name}` : ''}`} separator={''} to={`/releases/${item.releaseID}/${item.id}`} className={`track-name`} />
        <span className={`track-artists`}>
          {item.artists.map( (a, i) => (
            <JoinLinkage key={`artist-${a.id}-${i}`} label={`${a.name}`} separator={(i !== 0) ? `, ` : ``} to={`/artists/${a.slug}/${a.id}`} className={`link-enable`} />
          ))}
          {(includeRemixers && item.remixers) && item.remixers.map( (a, i) => (
            <JoinLinkage key={`remixer-${a.id}-${i}`} label={`${a.name}`} separator={(i !== 0) ? `, ` : ` / `} to={`/artists/${a.slug}/${a.id}`} className={`link-enable`} />
          ))}
        </span>
      </div>
      { item.is_explicit && <ExplicitTag className={`ET-row`} /> }
    </div>
  )
}

ColumnTrack.propTypes = {
  width: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  style: PropTypes.object,
  containerStyle: PropTypes.object,
  includeRemixers: PropTypes.bool
}

export default ColumnTrack;
